import { api } from "./api";

export async function getGlobalConfig(id: string) {
    // sem no-cache o navegador pode servir uma cópia antiga e segurar por
    // tempo indeterminado uma mudança feita no Studio (menu ou feature ligada/desligada)
    const { data } = await api.get(`database/global__c?q=_id:'${id}'`, {
        headers: { "cache-control": "no-cache" },
    });
    return data;
}